import { ErrorBoundary } from '@sentry/react';
import { FC, Suspense } from 'react';

import { LoadingIndicator } from '@eluve/components';

import { UsersList } from './UsersList';

export const UsersPage: FC<{}> = () => {
  return (
    <div className="container pb-8">
      <ErrorBoundary fallback={<div>There was an error</div>}>
        <Suspense fallback={<LoadingIndicator />}>
          <UsersList />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};
